import { render } from "./TowDays.vue?vue&type=template&id=5449962a"
import script from "./TowDays.vue?vue&type=script&lang=js"
export * from "./TowDays.vue?vue&type=script&lang=js"

import "./TowDays.vue?vue&type=style&index=0&id=5449962a&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__